module.exports = __webpack_public_path__ + "static/media/marketplace-product-img-3.54bc32af.svg";